import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import CreditScoreChart from "components/Pages/Dashboard/CreditScore/CreditScoreChart";
import { ENROLLMENT_STATUS } from "utils/constants";
import { USER_CREDIT_SCORE_QUERY } from "../mutations";

const AccountAndBillSummary = ({ numberOfLinkedAccounts, numberOfBills }) => {
  return (
    <div className="w-full bg-neutral-50 mt-4 py-5 flex items-center justify-center rounded">
      <div className="flex-1 flex flex-col text-center">
        <p className="text-3xl font-bold">{numberOfLinkedAccounts || 0}</p>
        <p className="text-sm font-medium">Accounts Linked</p>
      </div>
      <div style={{ width: 1, height: 50 }} className="bg-neutral-400" />
      <div className="flex-1 flex flex-col text-center">
        <p className="text-3xl font-bold">{numberOfBills || 0}</p>
        <p className="text-sm font-medium">Bills Detected</p>
      </div>
    </div>
  );
};

export const Overview = ({ numberOfLinkedAccounts, numberOfBills }) => {
  const { data: creditScoreData, loading: creditScoreLoading } = useQuery(
    USER_CREDIT_SCORE_QUERY,
    {
      variables: { limit: 1, order: "desc" },
    },
  );
  const creditScoreSummary = creditScoreData?.getUserCreditScore;
  const creditScore = creditScoreSummary?.credit_scores[0];
  const isBlurred =
    creditScoreLoading ||
    creditScoreSummary?.details?.status !== ENROLLMENT_STATUS.ENROLLED ||
    !creditScore;

  return (
    <div className="bg-white rounded-md shadow p-6 flex flex-col items-center">
      <p className="text-2xl font-bold text-black mt-1">Overview</p>
      <div className="mt-5">
        <CreditScoreChart
          creditScore={creditScore}
          isBlurred={isBlurred}
          modelLabelPlacement="center"
        />
      </div>
      <Link
        to="/credit-monitoring"
        className="underline mt-4"
        style={{ visibility: isBlurred ? "visible" : "hidden" }}
      >
        See my score
      </Link>
      <AccountAndBillSummary
        numberOfBills={numberOfBills}
        numberOfLinkedAccounts={numberOfLinkedAccounts}
      />
    </div>
  );
};
